import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Table from '../../common/Table'
import Pagination from "react-js-pagination";
import RowJobApply from './RowJobApply';
import MyPagination from "../../common/Pagination";

export default class TableJobApply extends Table {
    constructor(props) {
        super(props);
    }

    render() {
        let pageShow = [], hasBtnSearch;
        if(!this.props.onSearch){
            this.state.dataShow = this.props.data.filter(this.searchColumn);
            hasBtnSearch = false;
        }else{
            this.state.dataShow = this.props.data;
            hasBtnSearch = true;
        }

        for (let i = (this.state.activePage - 1) * this.state.itemsCountPerPage; i < this.state.dataShow.length && i < this.state.activePage * this.state.itemsCountPerPage; i++) {
            pageShow.push(this.state.dataShow[i]);
        }
        return (
            <React.Fragment>
                <table className="table table-stripped table-hover mb-0 table-jobapply table_responsive">
                    <thead className="thead-light">
                        <tr>
                        {this.props.header.map((item, i) =>
                            <th onClick={item.isSort ? this.handleSortAllData : ()=>{}} className={item.isSort ? (this.state.columnSort == item.name ? 'isSort sorting' : 'isSort') : ''} data-sorttype={this.state.typeSort} column={item.name} key={i}>{item.title}
                            </th>
                        )}
                        </tr>
                    </thead>
                    <tbody>
                        {pageShow.map((dataRow, i) => {
                            return <RowJobApply color="" removeClick={this.props.removeClick}　onEdit={this.handleEdit} key={i} data={dataRow} header={this.props.header}/>;
                        })}
                    </tbody>
                </table>
                <div className="card-footer">
                    { (this.props.hasOwnProperty('myPagination') && this.props.hasOwnProperty('searchConditions') && this.props.myPagination == 1) ? (
                        <div className="row">
                            <div className="col-sm-2">
                            </div>
                            <div className="col-sm-8">
                                <nav>
                                    <MyPagination
                                        onSearch={this.handleSearchByPage}
                                        searchConditions={this.props.searchConditions}
                                        lastPage={this.props.lastPage}
                                        currentPage={this.props.currentPage}
                                        />
                                </nav>
                            </div>
                            <div className="col-sm-2 text-right">
                                <strong>{this.props.total}件中{this.props.from}から{this.props.to}まで表示</strong>
                            </div>
                        </div>
                    ) : (
                        <div className="row"></div>
                        )
                    }
                </div>
            </React.Fragment>
        );
    }
}
